import { validateFieldsNatively as e, toNestError as t } from "@hookform/resolvers";
import { appendErrors as r } from "react-hook-form";

var o = function o(_o, n, a) {
  return void 0 === n && (n = {}), void 0 === a && (a = {}), function (s, i, c) {
    try {
      return Promise.resolve(function (t, r) {
        try {
          var u = (n.context && "development" === process.env.NODE_ENV && console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"), Promise.resolve(_o["sync" === a.mode ? "validateSync" : "validate"](s, Object.assign({
            abortEarly: !1
          }, n, {
            context: i
          }))).then(function (t) {
            return c.shouldUseNativeValidation && e({}, c), {
              values: t,
              errors: {}
            };
          }));
        } catch (e) {
          return r(e);
        }

        return u && u.then ? u.then(void 0, r) : u;
      }(0, function (e) {
        if (!e.inner) throw e;
        return {
          values: {},
          errors: t((o = e, n = !c.shouldUseNativeValidation && "all" === c.criteriaMode, (o.inner || []).reduce(function (e, t) {
            if (e[t.path] || (e[t.path] = {
              message: t.message,
              type: t.type
            }), n) {
              var o = e[t.path].types,
                  a = o && o[t.type];
              e[t.path] = r(t.path, n, e, t.type, a ? [].concat(a, t.message) : t.message);
            }

            return e;
          }, {})), c)
        };
        var o, n;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
};

export { o as yupResolver };